import React, { useContext, useMemo, useState } from 'react';

export interface UserValid {
	name?: boolean;
	role?: boolean;
	entitlements?: boolean;
	phoneNumber?: boolean;
	email?: boolean;
}

export interface UserErrors {
	name?: string;
	role?: string;
	entitlements?: string;
	phoneNumber?: string;
	email?: string;
}

export const defaultUserErrors: UserErrors = {
	name: undefined,
	role: undefined,
	entitlements: undefined,
	phoneNumber: undefined,
	email: undefined,
};

export const CreateUserContext = React.createContext<{
	userErrors: UserErrors;
	setUserErrors: React.Dispatch<React.SetStateAction<UserErrors>>;
	isUserValid: boolean;
}>({
	userErrors: defaultUserErrors,
	setUserErrors: () => {
		return;
	},
	isUserValid: false,
});

export const useCreateUserContext = () => useContext(CreateUserContext);

export function CreateUserProvider({ children }: { children: JSX.Element }) {
	const [userErrors, setUserErrors] = useState<UserErrors>(defaultUserErrors);
	const isUserValid = useMemo(
		() =>
			!userErrors.name &&
			!userErrors.role &&
			!userErrors.entitlements &&
			!userErrors.phoneNumber &&
			!userErrors.email,
		[userErrors],
	);

	return (
		<CreateUserContext.Provider
			value={{
				userErrors,
				setUserErrors,
				isUserValid,
			}}>
			{children}
		</CreateUserContext.Provider>
	);
}
